import { render } from "./SideNavCat.vue?vue&type=template&id=c776e742&scoped=true"
import script from "./SideNavCat.vue?vue&type=script&lang=js"
export * from "./SideNavCat.vue?vue&type=script&lang=js"

import "./SideNavCat.vue?vue&type=style&index=0&id=c776e742&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c776e742"],['__file',"src/components/mdbvue/pro/Navigation/SideNavCat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c776e742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c776e742', __exports__)) {
    api.reload('c776e742', __exports__)
  }
  
  module.hot.accept("./SideNavCat.vue?vue&type=template&id=c776e742&scoped=true", () => {
    api.rerender('c776e742', render)
  })

}


export default __exports__